module.exports = __webpack_public_path__ + "static/media/shield-check.7b9bb7c3.svg";